
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { OrderServiceStage, ViewType } from '@/types/orderServicer';

@Component({
  name: 'OrderServicerMyAdd',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  // create_company_id
  private stage = OrderServiceStage.SERVICE_STAGE;
  private vt = ViewType.ORDER_SERVICER_CREATE_MY;
  created() {
  }
}
